import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";

import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { useAuth } from '../components/AuthContext';
import { useTerminologia } from '../hooks/useTerminologia';

const Proveedores = () => {
    const toast = useRef(null);
    const HOST_API = process.env.REACT_APP_URL;
    const { administracionId } = useAuth();
    const t = useTerminologia();
    const [loadingBackdrop, setLoadingBackdrop] = useState(false);

    // â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const camelToHeader = (key) =>
        key.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()).trim();

    const formatValue = (value, type) => {
        if (value === null || value === undefined) return "";
        switch (type) {
            case "date":
                return new Date(value).toLocaleDateString("es-AR");
            case "currency":
                return typeof value === "number"
                    ? value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
                    : value;
            default:
                return typeof value === "object" ? JSON.stringify(value) : value;
        }
    };

    const flattenRow = (row) => {
        const flat = {};
        for (const [key, value] of Object.entries(row)) {
            if (typeof value === "object" && value !== null && !key.endsWith("_type")) {
                for (const [nestedKey, nestedValue] of Object.entries(value)) {
                    flat[nestedKey] = nestedValue;
                    flat[`${nestedKey}_type`] = row[`${key}_type`] ?? "currency";
                }
            } else {
                flat[key] = value;
            }
        }
        return flat;
    };

    // â”€â”€â”€ CatÃ¡logos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const [gruposGasto,    setGruposGasto]    = useState([]);
    const [barrios,        setBarrios]        = useState([]);
    const [condicionesIVA, setCondicionesIVA] = useState([]);

    useEffect(() => {
        axios.get(`${HOST_API}api/grupogastos/GetGrupoGastos?administracionId=${administracionId}`)
            .then((res) => setGruposGasto(res.data))
            .catch((err) => console.error("Error al obtener grupos de gasto:", err));

        axios.get(`${HOST_API}api/barrios/getBarrios?barrioId=0&administracionId=${administracionId}`)
            .then((res) => setBarrios(res.data))
            .catch((err) => console.error("Error al obtener barrios:", err));

        axios.get(`${HOST_API}api/condicioniva/GetCondicionesIVA`)
            .then((res) => setCondicionesIVA(res.data))
            .catch((err) => console.error("Error al obtener condiciones IVA:", err));
    }, [administracionId]);

    // â”€â”€â”€ Estado â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const initialFormData = {
        proveedorId: 0,
        nombreProveedor: "",
        cuit: "",
        condicionIvaId: "",
        telefono: "",
        email: "",
        activo: true,
        grupos: [],
        barrios: [],
    };

    const [formData, setFormData] = useState(initialFormData);
    const [visible, setVisible] = useState(false);
    const [proveedores, setProveedores] = useState([]);

    const handleChange = (campo, valor) => {
        setFormData((prev) => ({ ...prev, [campo]: valor }));
    };

    // â”€â”€â”€ Submit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            administracionId,
        };
        try {
            await axios.post(`${HOST_API}api/proveedores/SaveProveedor`, payload);
            setVisible(false);
            fetchProveedores();
        } catch (err) {
            console.error(err);
        }
    };

    // â”€â”€â”€ Fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const fetchProveedores = useCallback(async () => {
        setLoadingBackdrop(true);
        try {
            const response = await axios.get(`${HOST_API}api/proveedores/GetProveedores?administracionId=${administracionId}`);
            console.log(response.data);
            setProveedores(response.data);
        } catch (err) {
            console.error(err.message || "Error al obtener proveedores");
        } finally {
            setLoadingBackdrop(false);
        }
    }, [administracionId]);

    useEffect(() => {
        fetchProveedores();
    }, [fetchProveedores]);

    const proveedoresFlat = useMemo(() => proveedores?.map(flattenRow) ?? [], [proveedores]);

    const columns = useMemo(() => {
        if (!proveedoresFlat?.length) return [];
        const firstRow = proveedoresFlat[0];
        return Object.keys(firstRow)
            .filter((key) => !key.endsWith("_type") && key !== 'administracionId' && key !== 'condicionIvaId' && key !== 'fechaAlta' && key !== 'activo')
            .map((field) => ({
                field,
                type: firstRow[`${field}_type`] ?? "text",
                header: camelToHeader(field),
            }));
    }, [proveedores]);

    // â”€â”€â”€ Edit / Delete â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const handleEdit = async (row) => {
        try {
            const { data } = await axios.get(`${HOST_API}api/proveedores/GetProveedorById?proveedorId=${row.proveedorId}&administracionId=${administracionId}`);
            setFormData({
                proveedorId:     data.proveedorId     ?? 0,
                nombreProveedor: data.nombreProveedor  ?? '',
                cuit:            data.cuit             ?? '',
                condicionIvaId:  data.condicionIvaId   ?? null,
                telefono:        data.telefono         ?? '',
                email:           data.email            ?? '',
                activo:          data.activo           ?? true,
                grupos:          data.grupos           ?? [],
                barrios:         data.barrios          ?? [],
            });
        } catch (err) {
            console.error('Error al obtener proveedor:', err);
            setFormData({ ...initialFormData, ...row });
        }
        setVisible(true);
    };

    const handleDelete = (id) => {
        confirmDialog({
            message: '¿Estás seguro de eliminar este proveedor?',
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await axios.delete(`${HOST_API}api/proveedores/DeleteProveedor/${id}`);
                    fetchProveedores();
                } catch (err) {
                    console.error(err);
                }
            },
        });
    };

    // â”€â”€â”€ Render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    return (
        <>
            <h4>Proveedores</h4>
            <br />

            <ConfirmDialog />
            <Toast ref={toast} />
            <Dialog
                visible={loadingBackdrop}
                modal
                closable={false}
                showHeader={false}
                className="backdrop-dialog"
            >
                <ProgressSpinner style={{ width: '60px', height: '60px' }} />
            </Dialog>

            <div className="flex align-items-center gap-3 mb-3">
                <Button
                    label="Nuevo Proveedor"
                    icon="pi pi-plus"
                    onClick={() => { setFormData(initialFormData); setVisible(true); }}
                />
            </div>

            <Dialog
                header="Proveedor"
                visible={visible}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }}
                modal
                onHide={() => setVisible(false)}
            >
                <form className="p-fluid grid" onSubmit={handleSubmit}>
                    <div className="col-12">
                        <div className="col-12 flex flex-wrap gap-3 mt-3">

                            <div className="w-full md:w-6">
                                <label>Nombre</label>
                                <InputText
                                    type="text"
                                    value={formData.nombreProveedor || ""}
                                    onChange={(e) => handleChange("nombreProveedor", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>CUIT</label>
                                <InputText
                                    type="text"
                                    value={formData.cuit || ""}
                                    onChange={(e) => handleChange("cuit", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Condición IVA</label>
                                <Dropdown
                                    value={formData.condicionIvaId || null}
                                    options={condicionesIVA}
                                    optionLabel="descripcion"
                                    optionValue="condicionIvaId"
                                    onChange={(e) => handleChange("condicionIvaId", e.value)}
                                    placeholder="Seleccioná condición IVA"
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Teléfono</label>
                                <InputText
                                    type="text"
                                    value={formData.telefono || ""}
                                    onChange={(e) => handleChange("telefono", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4">
                                <label>Email</label>
                                <InputText
                                    type="email"
                                    value={formData.email || ""}
                                    onChange={(e) => handleChange("email", e.target.value)}
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-4 flex align-items-center gap-2 mt-2">
                                <Checkbox
                                    inputId="activo"
                                    checked={formData.activo}
                                    onChange={(e) => handleChange("activo", e.checked)}
                                />
                                <label htmlFor="activo">Activo</label>
                            </div>

                            <div className="w-full md:w-6">
                                <label>Grupos de Gasto</label>
                                <MultiSelect
                                    value={formData.grupos}
                                    options={gruposGasto}
                                    optionLabel="descripcion"
                                    optionValue="grupoGastoId"
                                    onChange={(e) => handleChange("grupos", e.value)}
                                    placeholder="Seleccionar grupos..."
                                    display="chip"
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="w-full md:w-6">
                                <label>{t.Barrios}</label>
                                <MultiSelect
                                    value={formData.barrios}
                                    options={barrios}
                                    optionLabel="nombreBarrio"
                                    optionValue="barrioId"
                                    onChange={(e) => handleChange("barrios", e.value)}
                                    placeholder={`Seleccionar ${t.barrios}...`}
                                    display="chip"
                                    className="p-inputtext-sm w-full"
                                />
                            </div>

                            <div className="col-12 mt-3">
                                <Button label="Guardar" icon="pi pi-save" type="submit" />
                            </div>

                        </div>
                    </div>
                </form>
            </Dialog>

            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={proveedoresFlat}
                        paginator
                        rows={10}
                        showGridlines
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay proveedores cargados"
                        className="p-datatable-gridlines bg-white"
                    >
                        {columns.map(({ field, header, type }) => (
                            <Column
                                key={field}
                                field={field}
                                header={header}
                                sortable
                                body={(row) => formatValue(row[field], type)}
                            />
                        ))}
                        <Column
                            header="Estado"
                            style={{ width: '8rem' }}
                            body={(row) => row.activo
                                ? <span className="customer-badge status-ingreso">Activo</span>
                                : <span className="customer-badge status-renewal" style={{ background: '#fde8e8', color: '#c0392b' }}>No Activo</span>
                            }
                        />
                        <Column
                            header="Acciones"
                            style={{ width: '8rem' }}
                            body={(row) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button icon="pi pi-pencil" rounded text severity="warning" onClick={() => handleEdit(row)} tooltip="Editar" />
                                    <Button icon="pi pi-trash" rounded className="btn-delete" onClick={() => handleDelete(row.proveedorId)} tooltip="Eliminar" />
                                </div>
                            )}
                        />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default Proveedores;
